import { withInstall } from '@bigin/utils'

import Col from './src/col.vue'

export const BCol = withInstall(Col)
export default BCol

export * from './src/col'
